/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { IComponent, IComponentProps, msdyn365Commerce } from '@msdyn365-commerce/core';
import * as React from 'react';

import classnames from 'classnames';

import { IRefinerApplyProps, RefinerApplyComponent } from './refiner-apply.component';

/**
 * Class names used in component.
 */
const componentClassName: string = 'msc-refiner-footer';
const actionsWrapperClassName: string = `${componentClassName}__actions`;
const extraActionsWrapperClassName: string = `${componentClassName}__extra-actions`;

/**
 * IRefinerFooterComponent interface.
 */
interface IRefinerFooterComponent extends IComponent<IRefinerFooterProps> {}

/**
 * IRefinerFooterProps interface.
 */
export interface IRefinerFooterProps extends IComponentProps<{}> {
    className?: string;
    refinerApplyProps?: IRefinerApplyProps;
    extraActions?: React.ReactNode;
}

/**
 * RefinerFooter component.
 * @param props - Configuration of the component.
 * @returns React node.
 */
const RefinerFooterFunctionalComponent: React.FC<IRefinerFooterProps> = (props: IRefinerFooterProps) => {
    const { className, refinerApplyProps, extraActions } = props;

    return (
        <div className={classnames(className, componentClassName)}>
            <div className={actionsWrapperClassName}>
                {extraActions && <div className={extraActionsWrapperClassName}>{extraActions}</div>}
                {refinerApplyProps && <RefinerApplyComponent {...refinerApplyProps} />}
            </div>
        </div>
    );
};

/**
 * RefinerFooter component.
 */
export const RefinerFooterComponent: React.FunctionComponent<IRefinerFooterProps> = msdyn365Commerce.createComponent<
    IRefinerFooterComponent
>('Refiner-Footer', {
    component: React.memo(RefinerFooterFunctionalComponent)
});
